import { View, ScrollView, Image, Linking, useWindowDimensions, Text } from 'react-native'
import { Button } from '@/src/common/components/Button'
import { DesignSystem } from '@/src/design-system'
import { SafeAreaView } from 'react-native-safe-area-context'
import { NotificationsApi } from '../store/api'
import { mesaColorNames, typography } from '@/src/common/theme'

function GoToSystemSettings() {
  const { width } = useWindowDimensions()
  const [ignoreNotificationPermissionRequestAt] =
    NotificationsApi.endpoints.ignoreNotificationPermissionRequestAt.useMutation()

  return (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: 'white',
        paddingHorizontal: 12,
        justifyContent: 'center',
        justifyItems: 'center',
        position: 'relative',
      }}
      edges={['top']}
    >
      <ScrollView>
        <View style={{ flex: 1 }}>
          <Text
            style={[
              typography['heading/heading2'],
              { flexDirection: 'row', alignItems: 'center', marginTop: 45 },
            ]}
          >
            Push Notifications
          </Text>
          <Text
            style={{
              paddingTop: 20,
              paddingBottom: 32,
              color: mesaColorNames['Greyscale/600 #505D64'],
              fontSize: 16,
            }}
          >
            Stay up to date with all of Mesa's programs and offers!
          </Text>

          <View style={{ justifyContent: 'center', alignItems: 'center' }}>
            <Image
              style={{ width: width, height: width * 1.52 }}
              source={require('../assets/images/go-to-notifications-settings.png')}
            />
          </View>
        </View>
      </ScrollView>

      <View style={{ position: 'absolute', bottom: 40, left: 0, right: 0, alignSelf: 'center' }}>
        <DesignSystem.Animate>
          <Button
            style={{ marginBottom: 12 }}
            onPress={() => void Linking.openSettings()}
            title="Enable Push Notifications"
          />
        </DesignSystem.Animate>

        <Button
          buttonStyle={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}
          onPress={() => void ignoreNotificationPermissionRequestAt()}
        >
          <Text
            style={[
              { color: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'] },
              typography['label/md-bold'],
            ]}
          >
            Not Now
          </Text>
        </Button>
      </View>
    </SafeAreaView>
  )
}

export const GoToNotificationsSettingsScreen = {
  name: 'go-to-notifications-settings',
  Screen: GoToSystemSettings,
} as const
